import * as Phaser from "phaser-ce"
import { Scale } from "../utils/Scale"

export class ThrobberSprite extends Phaser.Sprite {

    defaultScale: number
    defaultX: number
    defaultY: number
    private timer: Phaser.Timer

    constructor(game: Phaser.Game, x: number, y: number, key: string, defaultScale = 1) {
        super(game, x, y, key)
        this.defaultScale = defaultScale
        this.defaultX = x
        this.defaultY = y
        game.physics.enable(this, Phaser.Physics.ARCADE)
        Scale.scaleSprite(this, defaultScale)
    }

    /**
     * @param {number} delay - in millis
     * @param {number} duration - in millis
     * @param {number} framesPerThrob - lower is faster throbbing
     * @param {number} throbAmount - percent amount of throb.
     */
    throb = (delay = 0, duration?: number, framesPerThrob = 30, throbAmount = 0.02) => {

        const throbSpeed = 10
        const throbSequence: Array<ThrobIncrement> = []

        for (let i = 0; i < framesPerThrob; i++) {
            const throbIncrement = new ThrobIncrement()
            throbIncrement.scaleAmount = 1 + (throbAmount * i) / framesPerThrob
            throbIncrement.widthOffset = (this.width * throbIncrement.scaleAmount - this.width) / 2
            throbIncrement.heightOffset = (this.height * throbIncrement.scaleAmount - this.height) / 2
            throbSequence[i] = throbIncrement
        }

        this.timer = this.game.time.create(false)
        let throbBigger = true
        let currentIndex = 0
        let loopDuration = 0
        this.timer.loop(throbSpeed, () => {
            loopDuration += throbSpeed
            let throbIncrement: ThrobIncrement
            if (throbBigger) {
                throbIncrement = throbSequence[currentIndex]
                if (!throbIncrement) {
                    throbBigger = !throbBigger
                    currentIndex--
                    throbIncrement = throbSequence[currentIndex]
                } else {
                    currentIndex++
                }
            } else {
                throbIncrement = throbSequence[currentIndex]
                if (currentIndex === 0) {
                    currentIndex++
                    throbBigger = !throbBigger
                } else {
                    currentIndex--
                }
            }
            Scale.scaleSprite(this, this.defaultScale * throbIncrement.scaleAmount)
            this.x = this.defaultX - throbIncrement.widthOffset
            this.y = this.defaultY - throbIncrement.heightOffset
            if (duration && loopDuration > duration && currentIndex === 0) {
                this.timer.destroy()
            }
        })
        this.timer.start(delay)
    }

    stopThrob = () => {
        this.timer.destroy()
    }
}

class ThrobIncrement {
    widthOffset: number
    heightOffset: number
    scaleAmount: number
}
